import {
    BILLING_EVENTS, BILLING_EVENTS_LIST, FACEBOOK_AD_GENDERS_LIST, FACEBOOK_AD_STATUSES_LIST,
    FACEBOOK_SEARCH_TARGETING_TYPE_LIST,
    FACEBOOK_SEARCH_TARGETING_TYPES,
    OPTIMIZATION_GOALS, OPTIMIZATION_GOALS_LIST
} from "./facebook-constant";

export const AD_SET_FIELDS_LIST: any = [
    {attribute: "name", label: "Name", cssClass: ''},
    {attribute: "optimization_goal", label: "Optimization Goal", cssClass: ''},
    {attribute: "billing_event", label: "Billing Event", cssClass: ''},
    {attribute: "bid_amount", label: "Bid Amount", cssClass: ''},
    {attribute: "daily_budget", label: "Daily Budget", cssClass: ''},
    {attribute: "age_min", label: "Minimum Age", cssClass: ''},
    {attribute: "age_max", label: "Maximum Age", cssClass: ''},
    {attribute: "genders", label: "Genders", cssClass: ''},
    // {attribute: "campaign_id", label: "Campaign Id", cssClass: ''},
    // {attribute: "targeting", label: "Targeting", cssClass: ''},
    {attribute: "start_time", label: "Start Time", cssClass: ''},
    {attribute: "status", label: "Status", cssClass: ''},
];


export const AD_SET_INFO_FIELDS_LIST: any = [
    {attribute: "name", label: "Name", cssClass: ''},
    {attribute: "bid_amount", label: "Bid Amount", cssClass: ''},
    {attribute: "daily_budget", label: "Daily Budget", cssClass: ''},
    {attribute: "age_min", label: "Minimum Age", cssClass: ''},
    {attribute: "age_max", label: "Maximum Age", cssClass: ''},
    {attribute: "genders", label: "Genders", cssClass: ''},
    {attribute: "start_time", label: "Start Time", cssClass: ''},
    {attribute: "status", label: "Status", cssClass: '', isStatus: true},
];


export const AD_SET_INPUT_FIELDS: any = [
    {attribute: "name", label: "Name", type: 'text', group: 'detail', cssClass: 'w-full'},
    {
        attribute: "optimization_goal",
        label: "Optimization Goal",
        type: 'select',
        readOnly: false,
        group: 'detail',
        options: OPTIMIZATION_GOALS_LIST,
        default: OPTIMIZATION_GOALS.REACH,
        cssClass: ''
    },
    {
        attribute: "billing_event",
        label: "Billing Event",
        type: 'select',
        readOnly: false,
        group: 'detail',
        options: BILLING_EVENTS_LIST,
        default: BILLING_EVENTS.IMPRESSIONS,
        cssClass: ''
    },
    {attribute: "bid_amount", label: "Bid Amount", type: 'number', group: 'detail', cssClass: ''},
    {attribute: "daily_budget", label: "Daily Budget", type: 'number', group: 'detail', cssClass: ''},
    {attribute: "age_min", label: "Minimum Age", type: 'number', group: 'detail', cssClass: ''},
    {attribute: "age_max", label: "Maximum Age", type: 'number', group: 'detail', cssClass: ''},
    {
        attribute: "genders", label: "Genders", type: 'select', group: 'detail', options: FACEBOOK_AD_GENDERS_LIST,
        default: 'all', cssClass: ''
    },
    // {attribute: "campaignId", label: "Campaign Id", type: 'text', group: 'detail', cssClass: '', readOnly: true},
    // {attribute: "targeting", label: "Targeting", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "start_time", label: "Start Time", type: 'date', group: 'detail', cssClass: ''},
    {
        attribute: 'status',
        label: 'Status',
        type: 'select',
        readOnly: true,
        group: 'detail',
        options: FACEBOOK_AD_STATUSES_LIST,
        default: 'PAUSED',
        ccClass: ''
    }
];

export const DEFAULT_AD_SET = {
    bid_amount: 1000, // 10 Rs
    daily_budget: 30000, // 300 Rs
    start_time: new Date().toLocaleDateString(),
    optimization_goal: OPTIMIZATION_GOALS.REACH,
    billing_event: BILLING_EVENTS.IMPRESSIONS,
    status: 'PAUSED',
    age_min: 18,
    age_max: 65,
    genders: 'all',
    targeting: {
        geo_locations: {
            countries: ['US'],
        }
    }
};
